<template>
    <div class="p-fluid">
      <div class="p-col-12 p-lg-12">
        <div class="card card-w-title">
          <div class="manager-title-custom">{{title}}</div>
          <form id="frm_action">
            <div class="p-formgrid">
              <div class="">
                <div class="f-grid" style="margin: 0px 10px 0px 10px;">
                  <div class="f-grid-col">
                    <!-- <div class="mt-2" v-if="$store.getters.type == $constants.TYPE_USER.SUPPER_ADMIN">
                    </div> -->
                    <div class="mt-2">
                      <label class="txt-right">Công ty</label>
                      <InputText disabled v-model="company.name" type="text" class="text-box input-text-box" placeholder="Nhập"/>
                    </div>
                    <div class="mt-2">
                      <label class="txt-right">Mã giấy phép</label>
                      <InputText disabled v-model="atw_code" type="text" class="text-box input-text-box" placeholder="Nhập"/>
                    </div>
                    <div class="mt-2">
                      <label class="txt-right">Gói công việc SRA</label>
                      <InputText disabled v-model="sra_name" type="text" class="text-box input-text-box" placeholder="Nhập"/>
                    </div>
                    <div class="mt-2">
                      <label class="txt-right">Nhà thầu</label>
                      <InputText disabled v-model="contractor_txt" type="text" class="text-box input-text-box" placeholder="Nhập"/>
                    </div>
                    <div class="mt-2">
                      <label class="txt-right">Thời gian thực hiện đi - đến</label>
                      <Calendar disabled v-model="sra_data_date" selectionMode="range" dateFormat="dd/mm/yy" :showIcon="true" :manualInput="false" :showButtonBar="true" class="text-box input-text-box"/>
                    </div>
                    <div class="mt-2" style="padding-top: 5px;">
                      <label class="txt-right">ĐÁNH GIÁ NHÀ THẦU</label>
                    </div>
                    <div class="mt-2">
                      <label class="txt-right required">An toàn</label>
                      <div class="btn-group-css text-box input-text-box">
                        <button type="button" :class="['btn-switch', {selected : safe_value == 1}]" @click="changeAnToan(1)">Rất tệ</button>
                        <button type="button" :class="['btn-switch', {selected : safe_value == 2}]" @click="changeAnToan(2)">Tệ</button>
                        <button type="button" :class="['btn-switch', {selected : safe_value == 3}]" @click="changeAnToan(3)">Hoàn thành</button>
                        <button type="button" :class="['btn-switch', {selected : safe_value == 4}]" @click="changeAnToan(4)">Tốt</button>
                        <button type="button" :class="['btn-switch', {selected : safe_value == 5}]" @click="changeAnToan(5)">Rất tốt</button>
                      </div>
                    </div>
                    <div class="mt-2">
                      <label class="txt-right required">Chất lượng dịch vụ</label>
                      <div class="btn-group-css text-box input-text-box">
                        <button type="button" :class="['btn-switch', {selected : quality_value == 1}]" @click="changeChatLuongDichVu(1)">Rất tệ</button>
                        <button type="button" :class="['btn-switch', {selected : quality_value == 2}]" @click="changeChatLuongDichVu(2)">Tệ</button>
                        <button type="button" :class="['btn-switch', {selected : quality_value == 3}]" @click="changeChatLuongDichVu(3)">Hoàn thành</button>
                        <button type="button" :class="['btn-switch', {selected : quality_value == 4}]" @click="changeChatLuongDichVu(4)">Tốt</button>
                        <button type="button" :class="['btn-switch', {selected : quality_value == 5}]" @click="changeChatLuongDichVu(5)">Rất tốt</button>
                      </div>
                    </div>
                    <div class="mt-2">
                      <label class="txt-right required">Tiếp tục sử dụng cho lần sau</label>
                      <div class="btn-group-css text-box input-text-box">
                        <button type="button" :class="['btn-switch', {selected : continue_value == 1}]" @click="changeTiepTuc(1)">Không tiếp tục</button>
                        <button type="button" :class="['btn-switch', {selected : continue_value == 2}]" @click="changeTiepTuc(2)">Tiếp tục</button>
                      </div>
                    </div>
                    <div class="mt-2">
                      <label class="txt-right">Ghi chú</label>
                      <Textarea
                       v-model="note" 
                       :autoResize="true" rows="2" maxlength="14000" 
                       class="text-box input-text-box" 
                       placeholder="Nhập ghi chú"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <Toolbar class="fixed-bottom-toolbar">
                <template slot="right">
                  <Button
                    :label="$constants.TEXT_BUTTON.BACK"
                    @click="backToList()"
                    class="p-button-warning return-style-button" />
                  <Button v-if="mode == 'evalute'"
                    :label="$constants.TEXT_BUTTON.ADD"
                    @click="saveData()"
                    class="p-button-success main-style-button" />
                  <Button v-else
                    label="Chỉnh sửa"
                    @click="saveDataEdit()"
                    class="p-button-success main-style-button" />
                </template>
              </Toolbar>
            </div>
          </form>
        </div>
      </div>
    </div>
</template>
<script>
import ApiRepository from "@/core/ApiRepository";
// import moment from "moment-timezone";
// import jq from 'jquery';
export default {
  components: {
  },
  data() {
    return {
        code : '',
        company : {id : '', name : ''},
        company_id : null,
        factory : null,
        extend_date_show : null,
        contractor_txt : '',
        expiration_data_date : null,
        view_id : null,
        model : {},
        name : '',
        atw_code : '',
        sra_name : '',
        sra_data_date : [],
        safe_value : null,
        quality_value : null,
        continue_value : null,
        mode : 'evalute',
        title : 'Hoàn Thành & Đánh Giá Nhà Thầu',
        list_status : ['DONE','CLOSE_WAITTING','CLOSE_LV1','CLOSE'],
        note : '',
    }
  },
  async mounted () {
    if (!this.$commonFuction.isEmpty(this.$route.query)){
      if (!this.$commonFuction.isEmpty(this.$route.query.company_id)){
        this.company_id = this.$route.query.company_id;
      }
    }
    if (this.$route.params.id !== undefined) {
        this.view_id = this.$route.params.id
        await this.getData(this.$route.params.id);
        if (this.model !== undefined && Object.keys(this.model).length > 0) {
            // if (this.list_status.includes(this.model.status)){
            //   this.mode = 'edit';
            // }
            console.log("this.model===",this.model)
            this.atw_code = this.model.code
            this.company = this.model.company
            this.company_id = this.model.company.id
            this.factory = this.model.factory
            this.extend_date_show = this.model.extend_date ? new Date(this.model.extend_date) : null
            
            var contractor_txt = '-'
            if(this.model.sra){
              this.sra_name = this.model.sra.name ?? ''
            }
            if(this.model.contractor){
              contractor_txt = '['+this.model.contractor.code+'] '+this.model.contractor.name+''
            }
            this.contractor_txt = contractor_txt
            if(this.model.sra_date_start && this.model.sra_date_end){
              this.sra_data_date = [new Date(this.model.sra_date_start), new Date(this.model.sra_date_end)]
            }
            if(this.model.atw_contractor_evaluate){
              this.note = this.model.atw_contractor_evaluate.note ?? ''
              this.safe_value = this.model.atw_contractor_evaluate.safe_value ?? null
              this.quality_value = this.model.atw_contractor_evaluate.quality_value ?? null
              this.continue_value = this.model.atw_contractor_evaluate.continue_value ?? null
            }
            // if(this.model.expiration_start && this.model.expiration_end){
            //   this.expiration_data_date = [new Date(this.model.expiration_start), new Date(this.model.expiration_end)]
            // }
        }
    }
  },
  watch : {  
  },
  methods: {
    async saveData(){
      if(this.safe_value == null || this.quality_value == null || this.continue_value == null){
        alert('Vui lòng chọn các đánh giá nhà thầu')
        return
      }
      this.$commonFuction.is_loading(true);
      var param = {
        id: this.view_id,
        company_id: this.company_id,
        safe_value: this.safe_value,
        quality_value: this.quality_value,
        continue_value: this.continue_value,
        note: this.note,
      }
      console.log("param===",param)
      var that = this;
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = { "Authorization": "Bearer "+token, };
        await ApiRepository.post("/_api/atw/evaluate", param, {headers}).then((response) => {
          if (response.status === 200) {
              that.redirectEdit();
          } else {
            that.$toast.add({
              severity: 'error',
              summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
              detail: response.data.message,
              life: 3000
            });
            that.$commonFuction.is_loading(false);
          }
        }).catch((err) => {
          that.$toast.add({
            severity: 'error',
            summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
            detail: err,
            life: 3000
          });
          that.$commonFuction.is_loading(false);
        })
      }else{
        this.$commonFuction.is_loading(false);
      }
    },
    async redirectEdit() {
      var router_back = {path: '/admin/list-atw/view/'+this.view_id, query: {company_id: this.company_id}};
      this.$commonFuction.is_loading(false);
      this.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Lưu dữ liệu thành công', life: 3000 })
      this.$router.push(router_back);
    },
    changeAnToan(value){
      this.safe_value = value
    },
    changeChatLuongDichVu(value){
      this.quality_value = value
    },
    changeTiepTuc(value){
      this.continue_value = value
    },
    async getData(id) {
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
        "Authorization": "Bearer "+token,
        };
        var {data} = await ApiRepository.post("/_api/atw/view_detail", {id: id, company_id: this.company_id}, {headers});
        var value = data.data;
        this.model = value;
      }
    },
    backToList(){
      this.$router.push({path: '/admin/list-atw/view/'+this.view_id, query: {company_id: this.company_id}})
    }
  }

  
}
</script>
<style lang="scss">
  label {
    font-weight: bold;
  }
  .manager-title-custom{
    color: #1D3118;
    font-size: 18px;
    margin-bottom: 16px;
    padding-bottom: 10px;
    border-bottom: 1px solid #EEEEEE;
    font-weight: 700;
  }
  .p-inputnumber-buttons-stacked {
    .p-inputnumber-button-group {
      .p-button.p-button-icon-only { padding: 0 !important; }
    }
  }
  .note{ letter-spacing: 0px; color: #707070; margin-bottom: 24px; padding-top: 10px;}
  .p-formgrid { margin: 0;
    .p-panel-header {color: #000000; font-size: 18px; font-weight: bold; background: #EEEEEE;}
    .p-card-field{ padding: 24px;
      .p-field{
        .p-col-fixed { width: 300px; display: inline-block !important; margin: 0;}
        .p-col-width{width:500px !important; border-radius: 5px;
          &.disabled{background: #EEEEEE; border: 0 none; padding: 8px 10px;}
          .file-select{margin: 0;
            input[type="file"]{display: none;}
            .select-button{display: inline-block; cursor: pointer; background: transparent; border-radius: 5px;  color: #000000; font-size: 13px; padding: 3px 16px;  border: 1px solid #B4B4B4;}
          }
          &.pac-target-input{ height: 80px;  word-break: break-all; overflow-wrap: break-word;  resize: none;}
        }
        .box-images{ margin: 0; margin-top: 10px; position: relative;
          .item-img{width: 133px; height: 150px;  margin-right: 8px; margin-bottom: 8px; display: inline-flex; position: relative;
            img{max-width: 100%; height: auto;margin: 0 auto; object-fit: contain; padding: 5px;}
            .button-clear{border-radius: 5px; width: 24px; height: 24px; background: #F5564E; float: right; cursor: pointer; position: absolute; right: 0px;
              img{vertical-align: top;}
            }
          }
        }
        .p-invalid{display: block;}
      }
    }
    .fixed-bottom-toolbar{background: transparent; border: 0 none; margin-top: 22px; border-top: 1px solid #B4B4B4; padding: 0; padding-top: 30px;
      .p-button{width: auto; margin-right: 8px;
        &:last-child{margin-right: 0;}
      }
    }
  }
  .tab {
      display: flex;
      font-weight: 700;
      border-bottom: 1px solid #00000029;
  }
  .tab div {
      padding: 6px 8px;
      /* margin-right: 2px; */
      cursor: pointer;
  }
  .tab div.active {
      background-color: #fff;
      color: #0086C4;
      border-left: 1px solid #0086C4;
      border-right: 1px solid #0086C4;
      border-bottom: 3px solid #0086C4;
      border-top: 1px solid #0086C4;
  }
  .content {
      padding-top: 10px;
      display: none;
  }
  .content.active {
      display: block;
  }
  .button-container {
      display: flex;
      justify-content: flex-end; /* Căn chỉnh các nút về bên phải */
  }
  .button-container button {
      width: auto !important;
      margin-left: 5px; /* Khoảng cách giữa các nút */
  }
  .p-button-disa {
      color : #666666;
      background-color : #F2F3F7;
      border: 1px solid #F2F3F7;
  }
  .p-button-disa:hover {
      background-color: #F2F3F7 !important;
      border: 1px solid #F2F3F7 !important;
      color : #666666 !important;
  }
  .row-cs {
      padding-top : 6px;
  }
  .f-cus {
      color : #0086C4;
      font-weight: 700;
      font-size: 18px;
  }
  .title-css { 
    font-weight: bold;
  }
  .drop-cus {
    border: 1px solid #ccc;
    border-radius: 8px;
    padding: 10px;
  }
  .accordion-item {
    border: 1px solid #ddd;
    border-radius: 5px;
  }
  .accordion-label {
    display: block;
    padding: 8px;
    background-color: #DFE2E6;
    /* font-size: 15px; */
    font-weight: bold;
    cursor: pointer;
  }
  .accordion-content {
    margin-bottom: 5px;
  }
  .f-grid-v {
    display: flex;
    justify-content: space-between;
    flex-flow: row wrap;
    padding: 5px;
  }
  .f-grid-col-v {
    flex: 1 0;
    background-color: #F8F9FB;
    padding: 0px 10px 10px 10px;
    border-radius: 5px;
    margin: 5px 5px 5px 5px;
  }
  .left-cs {
      text-align: left;
      font-weight: bold;
      width: 120px;
      min-width: 120px;
  }
  .right-cs {
      text-align: right;
  }
  .left-cs-2 {
      text-align: left;
      font-weight: bold;
      width: 130px;
  }
  .container-tpl {
      display: flex; /* Sử dụng Flexbox để chia thành 2 phần */
      justify-content: space-between; /* Căn chỉnh nội dung sang hai bên */
      /* align-items: center; */
      padding-top : 5px;
  }
  .titel-cs {
      font-weight: bold;
  }
  .f-grid-col-v2 {
    background-color: #F8F9FB;
    padding: 0px 10px 5px 10px;
    border-radius: 5px;
    margin: 
    5px 10px 5px 10px;
  }
  .container-tpl-v2 {
    padding-top : 0px;
  }
  .btn-group-css {
    display: flex;
  }

  .btn-switch {
    width: 100px;
    padding: 8px;
    border: 1px solid #ccc;
    background-color: #fff;
    cursor: pointer;
    font-size: 1rem;
    transition: background-color 0.3s ease, color 0.3s ease;
    text-align: center; /* Căn giữa nội dung trong nút */
    white-space: nowrap; /* Ngăn chặn dòng văn bản bị gãy */
  }

  .btn-switch:hover {
    background-color: #aabcff;
  }

  .btn-switch.selected {
    background-color: #0086C4;
    color: white;
    /* font-weight: bold; */
  }
</style>